import Select from 'react-select';
import { Control, useController } from 'react-hook-form';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import { ReactSelectStyles } from '@components/profile/profileOverlay/overlays/ReactSelectStyles';
import { AdditionInfoVO } from '@domain/vo/match/ResumeAdditionInfoVO';

import classnames from 'classnames/bind';
import styles from './additionalInputModal.module.scss';
const cx = classnames.bind(styles);

interface Props extends AdditionInfoVO {
  control: Control;
}

const Dropdown = ({ additionInfoSn, choices, question, required, control }: Props) => {
  const {
    field,
    fieldState: { invalid },
    formState: { errors },
  } = useController({
    control,
    name: `${additionInfoSn}`,
  });

  return (
    <div>
      <h3 className={cx('formTitle')}>
        {question}
        {required && <span className={cx('require')}>필수</span>}
      </h3>
      <div className={cx('dropDownWrap')}>
        <Select
          placeholder={'내용을 선택해 주세요.'}
          className={cx('dropdown', { error: invalid })}
          styles={ReactSelectStyles}
          isSearchable={false}
          options={choices.map((choice) => ({ label: choice, value: choice }))}
          {...field}
        />
      </div>

      {invalid && <ErrorMessage errors={errors} name={field.name} />}
    </div>
  );
};

export default Dropdown;
